var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgCamera = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    fillRule: "evenodd",
    d: "m77.852 32.789 2.033 14.467 1.902 13.535c.769 5.47-3.042 10.526-8.51 11.294l-52.503 7.38c-3.937.552-7.575-2.241-8.134-6.22L8.327 42.56c-.56-3.993 2.181-7.67 6.105-8.221l11.098-1.56a1.926 1.926 0 0 0 1.373-.89l3.98-7.392a5.502 5.502 0 0 1 3.906-2.543l11.947-1.679a5.524 5.524 0 0 1 4.455 1.368l5.863 6.009c.425.386 1 .556 1.566.477l11.097-1.56c3.938-.553 7.575 2.24 8.135 6.22Zm-28.869-6.206c-.675-.798-1.542-1.192-2.392-1.072l-10.207 1.434c-.85.12-1.574.737-2.004 1.69l-.84 3.019 17.07-2.4-1.627-2.671ZM67.335 37.11l2.198-.309c1.321-.185 2.246-1.43 2.058-2.771-.188-1.34-1.42-2.282-2.742-2.097l-2.198.31c-1.322.185-2.247 1.43-2.058 2.77.188 1.34 1.42 2.283 2.742 2.097Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M79.885 47.256 77.85 32.789c-.559-3.98-4.196-6.773-8.134-6.22L58.62 28.13c-.567.08-1.14-.09-1.566-.477l-5.864-6.01a5.524 5.524 0 0 0-4.454-1.367l-11.947 1.679a5.502 5.502 0 0 0-3.906 2.543l-3.98 7.392c-.302.489-.807.81-1.373.89l-11.098 1.56c-3.924.551-6.666 4.228-6.105 8.22l4.313 30.686c.56 3.979 4.197 6.772 8.134 6.22l51.725-7.27"
  }), React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M28.805 54.42c-1.284-9.134 4.97-17.57 13.99-18.838 9.021-1.268 17.371 5.117 18.641 14.253 1.284 9.134-4.97 17.571-13.99 18.839-9.008 1.266-17.356-5.105-18.641-14.253Zm27.582-5.176c1.604 6.312-2.14 12.726-8.36 14.327-6.221 1.6-12.564-2.218-14.168-8.529-1.603-6.311 2.14-12.726 8.36-14.327 6.221-1.6 12.564 2.218 14.168 8.53Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: borderColor,
    d: "m61.436 49.835-.743.103v.001l.743-.104ZM48.026 63.57l-.186-.726.187.726Zm8.361-14.327-.727.185.727-.185Zm-22.528 5.798.727-.185-.727.185Zm8.36-14.327.187.727-.187-.727Zm.472-5.876c-9.442 1.327-15.969 10.152-14.63 19.686l1.486-.209C28.32 45.582 34.3 37.533 42.9 36.325l-.208-1.486Zm19.488 14.892c-1.326-9.538-10.048-16.218-19.488-14.892l.208 1.486c8.602-1.21 16.58 4.879 17.794 13.613l1.486-.207ZM47.55 69.416C56.991 68.09 63.52 59.266 62.18 49.73l-1.486.21c1.228 8.734-4.751 16.782-13.352 17.991l.21 1.486Zm-19.488-14.89c1.342 9.548 10.061 16.215 19.488 14.89l-.209-1.485c-8.587 1.207-16.564-4.867-17.794-13.614l-1.485.208Zm20.152 9.771c6.63-1.706 10.603-8.535 8.9-15.237l-1.454.369c1.504 5.92-2.009 11.92-7.82 13.416l.374 1.452Zm-15.082-9.07c1.704 6.704 8.45 10.777 15.082 9.07l-.374-1.452c-5.81 1.495-11.75-2.07-13.254-7.988l-1.454.37Zm8.9-15.238c-6.63 1.707-10.603 8.535-8.9 15.238l1.454-.37c-1.504-5.92 2.01-11.92 7.82-13.415l-.373-1.453Zm15.082 9.07c-1.704-6.704-8.45-10.777-15.081-9.07l.373 1.453c5.81-1.495 11.75 2.068 13.254 7.987l1.454-.37Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M48.027 63.57c6.221-1.6 9.964-8.014 8.36-14.326-1.603-6.311-7.946-10.13-14.167-8.529-6.22 1.601-9.964 8.016-8.36 14.327 1.603 6.311 7.946 10.13 14.167 8.529ZM48.983 26.583c-.676-.798-1.542-1.192-2.392-1.072l-10.208 1.434c-.849.12-1.573.737-2.003 1.69l-.841 3.019 17.07-2.4-1.626-2.671ZM69.532 36.802l-2.197.31c-1.322.185-2.554-.758-2.743-2.098-.188-1.34.737-2.585 2.058-2.77l2.198-.31c1.322-.186 2.554.757 2.743 2.097.188 1.34-.737 2.586-2.058 2.771Z"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M79.569 71.034c-.469-.2-11.512-5.104-12.454-11.804-.453-3.227 1.765-6.23 4.96-6.68a5.804 5.804 0 0 1 5.501 2.351c.739-1.986 2.496-3.474 4.64-3.775 3.182-.448 6.154 1.812 6.609 5.053.942 6.7-8.322 14.459-8.717 14.779l-.247.202-.293-.126Z"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-70)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M82.723 54.736c1.228-.173 2.368.699 2.542 1.943"
  }));
};
export default SvgCamera;